export type RecoveryRateOption = {
  id: string;
  recoveryRate: number;
};

export const recoveryRateOptions: RecoveryRateOption[] = [
  { id: '1', recoveryRate: 12.5 },
  { id: '2', recoveryRate: 20 },
];
